import _isEmpty from 'lodash/isEmpty';
import _omit from 'lodash/omit';
import _findIndex from 'lodash/findIndex';
import _filter from 'lodash/filter';
import _has from 'lodash/has';

export const calculateInitialFilterOptions = options =>
  options.reduce(
    (acc, item) => ({
      ...acc,
      [item.name]: item.value,
    }),
    {},
  );

export const calculateFinalFilterParams = params =>
  Object.keys(params).reduce((acc, key) => {
    const value = params[key];

    if (!(key === 'archived' && value === true)) {
      acc[key] = value;
    }

    return acc;
  }, {});

export const calculateFinalParams = (filterOptions, paginationOptions) =>
  _omit(Object.assign({}, paginationOptions, filterOptions), ['name', 'value']);

export const calculateNewFilterOption = (options, obj) => {
  if (!_isEmpty(obj)) {
    return options.map(item => ({
      ...item,
      value: item.name === obj.name ? obj.value : item.value,
    }));
  }

  return options;
};

export const dropBrokenGroups = list => {
  const newList = list.filter(item => item.rules.length > 0 || item.visible);
  return newList.map((o, i) => ({ ...o, order: i }));
};

export const mergeRulesWithGroups = list => {
  // TODO drop this when api fixed
  const newList = list.filter(item => item.rules.length > 0 || item.visible);
  return newList.map(item =>
    item.visible === false && item.rules.length > 0
      ? { ...item.rules[0], order: item.order }
      : item,
  );
};

export const dropItemFromList = (list, rule) => {
  const index = _findIndex(list, {
    id: rule.rule_group,
  });

  return index !== -1
    ? list.map(n =>
        _has(n, 'rules')
          ? { ...n, rules: n.rules.filter(m => m.id !== rule.id) }
          : n,
      )
    : _filter(list, o => o.id !== rule.id);
};
